<template>

    <Transition name="fade">
      <CustomerManage v-if="isCustomerManage" :isCustomerManage="isCustomerManage" :customerID="customerID" :toggleManage="toggleManage" :manageMode="manageMode"/>
    </Transition>
    
    <div class="py-4 container-fluid">
      <div class=" row">
        <div class="col-12">
          <div class="card">
            <div class="card-header pb-0">
              <div class="row">
                <div class="col-md-4">
                  <span class="mb-0" style="font-size: 1rem; line-height: 1.625; font-weight: 600; margin-top: 0; color: #344767"><i class="fas fa-dog onmaum-text-pet"></i> 혼디도랑 고객 정보</span>
                </div>
                <div class="col-md-1">
  
                </div>
                <div class="col-md-1 onmaum-text-right">
                  <i class="far fa-star onmaum-font-2rem onmaum-text-alarm onmaum-text-cursor" v-if="!this.$store.state.customer.isFavorite" @click="setFavor();"></i><!-- 미선택 -->
                  <i class="fas fa-star onmaum-font-2rem onmaum-text-alarm onmaum-text-cursor" v-if="this.$store.state.customer.isFavorite" @click="setFavor();"></i><!-- 선택 -->
                </div>
                <div class="col-md-2">
                  <input type="text" class="form-control" placeholder="검색어 입력" @keydown.enter="search($event.target.value)"/>
                </div>
                <div class="col-md-2 text-center">
                  <button class="btn btn-onmaum btn-sm ms-auto w-100" @click="goManage('insert', 0)">고객추가</button>
                </div>
                <div class="col-md-2 text-center">
                  <button class="btn btn-success btn-sm ms-auto w-100" @click="downloadExcel()">엑셀출력</button>
                </div>
              </div>
            </div>
            <div class="card-body px-0 pt-0 pb-2">
              <div class="table-responsive p-0 onmaum-h-60-v onmaum-overflow onmaum-overflow-type02">
                <table class="table table-striped text-center table align-items-center mb-0" id="customerTable" style="table-layout: fixed;">
                  <thead>
                    <tr>
                      <th class="text-secondary text-sm font-weight-bolder opacity-7" scope="col" width="5%" >번호</th>
                      <th class="text-secondary text-sm font-weight-bolder opacity-7" scope="col" width="7%" >이름</th>
                      <th class="text-secondary text-sm font-weight-bolder opacity-7" scope="col" width="9%" >주민등록번호</th>
                      <th class="text-secondary text-sm font-weight-bolder opacity-7" scope="col" width="10%" >휴대전화</th>
                      <th class="text-secondary text-sm font-weight-bolder opacity-7" scope="col" width="0%" hidden>주소</th>
                      <th class="text-secondary text-sm font-weight-bolder opacity-7" scope="col" width="0%" hidden>직업</th>
                      <th class="text-secondary text-sm font-weight-bolder opacity-7" scope="col" width="7%" >담당플래너</th>
                      <th class="text-secondary text-sm font-weight-bolder opacity-7" scope="col" width="8%" >품종</th>
                      <th class="text-secondary text-sm font-weight-bolder opacity-7" scope="col" width="7%" >이름</th>
                      <th class="text-secondary text-sm font-weight-bolder opacity-7" scope="col" width="5%" >나이</th>
                      <th class="text-secondary text-sm font-weight-bolder opacity-7" scope="col" width="7%" >입양</th>
                      <th class="text-secondary text-sm font-weight-bolder opacity-7" scope="col" width="7%" >중성화</th>
                      <th class="text-secondary text-sm font-weight-bolder opacity-7" scope="col" width="10%" >등록번호</th>
                      <th class="text-secondary text-sm font-weight-bolder opacity-7" scope="col" >메모</th>
                      <th class="text-secondary text-sm font-weight-bolder opacity-7" scope="col" width="0%" hidden>체결정보</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(customer, i) in customerInfo" :key="i">
                      <!-- 번호 -->
                      <td>
                        <p class="text-sm font-weight-bold mb-0" style="border-radius: 10px;" :style="customer.contract.filter(a => a.flag).length > 0?'background:#5e72e450;':'background: #FF000050;'">{{ i + 1 }}</p>
                      </td>
                      <!-- 이름 -->
                      <td>
                        <p class="text-sm text-onmaum-hover font-weight-bold mb-0" @click="goManage('select', customer._id);">
                          {{ `${customer.name}` == '' ? '이름없음' : `${customer.name}` }}
                        </p>
                      </td>
                      <!-- 주민등록번호 -->
                      <td>
                        <p v-if="this.$store.state.login.userType == '기타사용자'" class="text-sm font-weight-bold mb-0" id="registNumber01">{{ customer.decrypt_regist_number.substr(0,6) + '-' + customer.decrypt_regist_number.substr(6,1) + '******' }}</p>
                        <p v-if="this.$store.state.login.userType != '기타사용자'" class="text-sm font-weight-bold mb-0" id="registNumber02">{{ customer.decrypt_regist_number.substr(0,6) + '-' + customer.decrypt_regist_number.substr(6,7) }}</p>
                      </td>
                      <!-- 휴대전화 -->
                      <td class="align-middle text-center text-sm">
                        <p class="text-sm font-weight-bold mb-0">{{ `(${customer.phone.telecom}) ${setPhoneNum(customer.phone.phone)}` }}</p>
                      </td>
                      <!-- 주소 -->
                      <td class="align-middle" hidden>
                        <p class="text-sm font-weight-bold mb-0 onmaum-text-ellipsis">{{ customer.address.address }}<br></p>
                        <p class="text-sm font-weight-bold mb-0 onmaum-text-ellipsis">{{ customer.address.extra_address }}<br></p>
                        <p class="text-sm font-weight-bold mb-0 onmaum-text-ellipsis">{{ customer.address.detail_address }}</p>
                      </td>
                      <!-- 직업 -->
                      <td class="align-middle" hidden>
                        <p class="text-sm mb-0"><span class="font-weight-bold">{{ customer.job }}</span></p>
                      </td>
                      <!-- 담당플래너 -->
                      <td class="align-middle">
                        <p class="text-sm mb-0"><span class="font-weight-bold">{{ customer.planner.planner01.planner_name }}</span></p>
                      </td>
                      <!-- 품종 -->
                      <td class="align-middle">
                        <p class="text-sm mb-0" v-for="(pet, i) in customer.petInfo" :key="i">
                          <span class="font-weight-bold">{{ `(${pet?pet.petKind??'':''})${pet?pet.petBreed??'':''}` }}</span>
                        </p>
                      </td>
                      <!-- 이름 -->
                      <td class="align-middle">
                        <p class="text-sm mb-0" v-for="(pet, i) in customer.petInfo" :key="i">
                          <span class="font-weight-bold">{{ `${pet?pet.petName??'':''}` }}</span>
                        </p>
                      </td>
                      <!-- 나이 -->
                      <td class="align-middle">
                        <p class="text-sm mb-0" v-for="(pet, i) in customer.petInfo" :key="i">
                          <span class="font-weight-bold">{{ pet?pet.petAge??'':'' }}</span>
                        </p>
                      </td>
                      <!-- 입양 여부 -->
                      <td class="align-middle">
                        <p class="text-sm mb-0" v-for="(pet, i) in customer.petInfo" :key="i">
                          <span class="badge bg-success onmaum-font-0_5rem"  v-if="pet?pet.petAdopt??false:false">입양</span>
                        </p>
                      </td>
                      <!-- 중성화 여부 -->
                      <td class="align-middle">
                        <p class="text-sm mb-0" v-for="(pet, i) in customer.petInfo" :key="i">
                          <span class="badge bg-primary onmaum-font-0_5rem" v-if="pet?pet.petNeutral??false:false">중성화</span>
                        </p>
                      </td>
                      <!-- 등록번호 -->
                      <td class="align-middle">
                        <p class="text-sm mb-0" v-for="(pet, i) in customer.petInfo" :key="i">
                          <span class="font-weight-bold">{{ pet?pet.petRegNum??'':'' }}</span>
                        </p>
                      </td>
                      <!-- 메모 -->
                      <td class="align-middle" style="text-align: left;">
                        <p class="text-sm font-weight-bold mb-0 onmaum-text-ellipsis" v-for="(text, i) in customer.memo" :key="i">{{(customer.memoDate[i]??'') + ' ' + text }}<br v-if="customer.memo.length - 1 != i"></p>
                      </td>
                      <!-- 체결현황 -->
                      <td class="align-middle" style="text-align: left;" hidden>
                        <p class="text-sm mb-0" v-for="(contract, i) in customer.contract" :key="i">{{ `${i + 1}. ${contract.date}|${contract.company}|${contract.price}`}}<br v-if="customer.contract.length - 1 != i"></p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import * as Xlsx from 'xlsx/xlsx.mjs'
  import CustomerManage from './PetCustomerManage.vue'
  
  export default {
      name: 'PetCustomerInfo',
      data() {
        return {
          isCustomerManage: false,
          customerID: 0,
          manageMode: 'select',
          searchText: '',
        }
      },
      components:{
        CustomerManage,
      },
      methods:{
        goManage(mode, id){
          this.isCustomerManage = true;
          this.customerID = id;
          this.manageMode = mode;
        },
  
        toggleManage(){
          this.isCustomerManage = !this.isCustomerManage;
        },
  
        downloadExcel(){
          console.log(document.getElementById('customerTable'));
          let d = new Date();
          let day = '' + d.getFullYear() + (d.getMonth() + 1 < 10 ? '0' + (d.getMonth() + 1) : d.getMonth() + 1) + (d.getDate() < 10 ? '0' + d.getDate() : d.getDate()) + (d.getHours() < 10 ? '0' + d.getHours() : d.getHours()) + (d.getMinutes() < 10 ? '0' + d.getMinutes() : d.getMinutes());
          const workBook = Xlsx.utils.book_new();
          const workSheet = Xlsx.utils.table_to_sheet(document.getElementById('customerTable'));
          Xlsx.utils.book_append_sheet(workBook, workSheet, '혼디도랑 고객 정보');
          Xlsx.writeFile(workBook, `혼디도랑고객정보_${day}.csv`);
        },
  
        //검색
        search(text){
          this.$store.state.customer.searchText = text;
        },
  
        //즐겨찾기 보기 설정
        setFavor(){
          this.$store.state.customer.isFavorite = !this.$store.state.customer.isFavorite;
        },
  
        //휴대전화 포맷
        setPhoneNum(a){
          let temp = a.replaceAll('-', '');
  
          if(temp.length == 11){
            return temp.toString().replace(/^(\d{3})(\d{4})(\d{4})$/, '$1-$2-$3');
          }else if(temp.length == 10 && temp.substring(0, 2) == '02'){
            return temp.toString().replace(/^(\d{2})(\d{4})(\d{4})$/, '$1-$2-$3');
          }else if(temp.length == 10 && temp.substring(0, 2) != '02'){
            return temp.toString().replace(/^(\d{3})(\d{3})(\d{4})$/, '$1-$2-$3');
          }else{
            return temp.toString().replace(/\B(?=(\d{4})+(?!\d))/g, '-');
          }
        },
      },
  
      computed: {
        customerInfo(){
          return this.$store.getters.getCustomerInfo;
        }
      },
  
      mounted() {
        //고객 정보 가져오기
        this.$store.dispatch('getCustomerInfo');
      },

      beforeRouteLeave(to, from ,next){
      if(this.isCustomerManage) {
        next(false);
        this.toggleManage();
      } else {
        next();
      }
    },
  }
  </script>
  
  <style>
  
  </style>